/**
 * Returns the vehicle registration (rego) for display.
 * @param {Object} vehicle - Vehicle object (may have rego)
 * @returns {string} Rego or empty string if missing
 */
export function formatVehicleLabel(vehicle) {
  if (!vehicle || typeof vehicle !== "object") {
    return "";
  }
  const rego = vehicle.rego && String(vehicle.rego).trim();
  return rego || "";
}
